<template>
	<v-dialog v-model="dialog" persistent max-width="800">
		<v-card>
			<s-toolbar label="Vista Previa" dark color="#8e8f91" close @close="closeDialog">
				<v-tooltip bottom="">
					<template v-slot:activator="{ on }">
						<v-btn text small style="margin-right:5px;" v-on="on" @click="closeDialog"> <v-icon
								style="font-size:18px;">
								mdi-arrow-left</v-icon></v-btn>
					</template>
					<span>Regresar</span>
				</v-tooltip>
			</s-toolbar>
			<v-container>
				<v-row>
					<v-col>
						<div class="email-container">
							<div class="email-header">
								<div style="display: flex; align-items: center; gap: 10px">
									<h1 class="email-title">Equipo de Desarrollo TI: Confirmación de ticket</h1>
									<span class="email-label">
										Recibidos
										<span class="close-icon">×</span>
									</span>
								</div>
								<div class="email-actions">
									<v-icon style="cursor: pointer">mdi-printer-outline mdi-18px</v-icon>
									<v-icon style="cursor: pointer">mdi-open-in-new</v-icon>
								</div>
							</div>

							<div class="sender-info">
								<div class="profile-image">
									<img src="/static/logo_sp.png" width="160" />
								</div>
								<div class="sender-details">
									<div class="sender-email">notificaciones@sunshineperu.com</div>
									<div class="recipient">
										para mí
										<v-icon>mdi-menu-down</v-icon>
									</div>
								</div>
								<div class="email-timestamp">
									<v-icon style="cursor: pointer">mdi-attachment</v-icon>
									<span> (hace un momento)</span>
								</div>
								<div class="email-options">
									<v-icon style="transform: translateY(-2px)">mdi-star-outline</v-icon>
									<i style="color: #5f6368; transform: translateY(-2px)" class="far fa-smile"></i>
									<v-icon style="transform: translateY(-2px)">mdi-arrow-left-top</v-icon>
									<v-icon style="transform: translateY(-2px)">mdi-dots-vertical</v-icon>
								</div>
							</div>

							<div class="email-content">

								<!-- ================= MENSAJE EDITABLE ================= -->
								<div :style="{
									flexDirection: isEditing ? 'column' : 'row',
									marginBottom: '24px',
									display: 'flex',
									gap: '10px'
								}">

									<!-- Vista normal (mensaje renderizado) -->
									<div v-show="!isEditing" style="flex: 1;" v-html="textContent"></div>

									<!-- Editor Quill -->
									<div v-show="isEditing" style="flex: 1;">
										<div :id="editorId"></div>
									</div>

									<!-- Botón editar -->
									<div v-show="!isEditing">
										<v-icon style="cursor: pointer" @click="enableEditing">
											mdi-receipt-text-edit-outline
										</v-icon>
									</div>

									<!-- Botón guardar -->
									<div v-show="isEditing">
										<v-btn style="cursor: pointer; display: flex; gap: 5px;" @click="saveText"
											color="success" block small>
											Guardar
											<v-icon>mdi-content-save-outline</v-icon>
										</v-btn>
									</div>

								</div>

								<!-- ================= DIVISOR ================= -->
								<div class="email-divider"></div>

								<div class="attachment-section-container">
									<div :style="{ display: 'flex', flexDirection: 'column', gap: '8px' }">
										<label class="email-label">Correo destinatario:</label>

										<!-- Vista normal -->
										<div v-show="!isEditingEmail" class="email-value"
											@click="enableEmailEditing"
											style="cursor: text; color: #1976d2; font-style: normal; text-decoration: underline;">
											<!-- Si hay correo lo muestra, si no, mensaje de placeholder -->
											{{ selectedEmail || 'No hay correo registrado. Haga clic para ingresar uno.' }}
										</div>

										<!-- Input editable -->
										<v-text-field v-show="isEditingEmail" v-model="selectedEmail"
											placeholder="Ingrese correo" outlined hide-details style="width: 100%;"
											@blur="saveEmailText" @keyup.enter="saveEmailText"></v-text-field>
									</div>
								</div>

								<!-- ================= PREVIEW DEL TICKET (QR) ================= -->
								<div class="attachment-container" style="
								position: relative;
								margin: 0 auto;
								border: 1px solid #e0e0e0;
								border-radius: 4px;
								padding: 16px;
								background: #fff;
								max-width: 100%;
								">
									<div class="attachment-preview" style="text-align: center;">
										<!-- 🔥 SOLO mostramos el ticket -->
										<div v-html="ticketHTML"></div>
									</div>
								</div>

							</div>
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-btn block color="success" :loading="dialogLoading"
							@click="sendMailTicket"><v-icon>mdi-gmail</v-icon>&nbsp;Enviar</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</v-card>
	</v-dialog>
</template>

<script>
import _sTaskService from '@/services/InformationTechnology/TaskService.js';
// Make sure to use the global Quill instance or import it if needed.
// 'Quill' used in Task.vue assumes Quill is globally available

export default {
    name: 'TaskEmailPreviewModal',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        task: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            filterEmail: {
				EmailBody: '',
				Affair: '',
			},
            isEditing: false,
            quill: null,
            textContent: '',
            ticketHTML: '',
            selectedEmail: '',
            isEditingEmail: false,
            dialogLoading: false,
			editorId: 'editor-' + Math.random().toString(36).substr(2, 9)
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    watch: {
        dialog(val) {
            if (val && this.task && this.task.TskID) {
                this.initData();
               
				this.$nextTick(() => {
					this.isEditing = false;
					this.isEditingEmail = false;
				});
            }
        }
    },
    methods: {
        initData() {
            this.textContent = `Estimado(a),<br><br>
			Hemos recibido su requerimiento: <strong>"${this.task.TskTitle}"</strong>.<br><br>
			Para cualquier consulta o seguimiento, por favor comuníquese con nuestro equipo de soporte al correo: 
			<a href="mailto:desarrollador.ti@gmail.com">desarrollador.ti@gmail.com</a>.<br><br>
			Atte,<br>
			Equipo de Desarrollo`;

            this.selectedEmail = this.task.PemEmailPrsAttended || '';
            this.ticketHTML = this.generateTicketHTML(this.task);
            this.filterEmail.Affair = `Ticket ${this.task.TskID}`;
        },
        closeDialog() {
            this.dialog = false;
        },
        generateTicketHTML(item) {
			if (!item) return '';
			return `
				<table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; width: auto;">
				<tr>
					<!-- Columna QR -->
					<td style="padding-right: 8px; vertical-align: top;">
					<img 
						src="https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${item.TskID}" 
						width="120" 
						height="120" 
						style="display: block;"
						alt="QR Ticket"
					/>
					</td>

					<!-- Columna Ticket info -->
					<td style="vertical-align: top;">
					<h2 style="margin: 0; font-size: 18px; line-height: 1.2;">TICKET</h2>
					<p style="margin: 4px 0 0 0; font-size: 14px; line-height: 1.2;">
						<strong>ID:</strong> ${item.TskID}
					</p>
					</td>
				</tr>
				</table>
			`;
		},
        enableEditing() {
			this.isEditing = true;
			this.$nextTick(() => {
				if (!this.quill) {
					this.quill = new Quill('#' + this.editorId, {
						theme: 'snow'
					});
					this.quill.clipboard.dangerouslyPasteHTML(
						this.textContent || ''
					);
				} else {
					this.quill.clipboard.dangerouslyPasteHTML(
						this.textContent || ''
					);
				}
			});
		},
        saveText() {
			if (this.quill) {
				this.textContent = this.quill.root.innerHTML;
			}
			this.isEditing = false;
		},
        enableEmailEditing() {
			this.isEditingEmail = true;
			this.$nextTick(() => {
				const input = this.$el.querySelector('input');
				if (input) input.focus();
			});
		},
        saveEmailText() {
			if (this.selectedEmail && !this.validateEmail(this.selectedEmail)) {
				this.$fun.alert("Por favor ingrese un correo válido.", "warning");
				this.$nextTick(() => {
					const input = this.$el.querySelector('input');
					if (input) input.focus(); // vuelve a enfocar el input
				});
				return;
			}
			this.isEditingEmail = false;
		},
        validateEmail(email) {
			const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return re.test(email);
		},
        sendMailTicket() {
			// 1️⃣ Validar correo antes de nada
			if (!this.selectedEmail || !this.validateEmail(this.selectedEmail)) {
				this.$fun.alert("Por favor ingrese un correo válido.", "warning");
				return;
			}

			const finalBody = `
				<div style="font-family: Arial, sans-serif;">
				${this.textContent}
				<br><br>
				${this.ticketHTML}
				</div>
			`;

			const correo = {
				EmailPrs: this.selectedEmail,
				EmailBody: finalBody,
				Affair: `Equipo de Desarrollo TI: Recibimos su requerimiento - ticket ${this.task.TskID}`
			};

			this.$fun.alertFull("Esta de seguro de enviar los correos?", "question")
				.then(res => {
					if (res.value) {
						this.dialogLoading = true;
						_sTaskService.SendMailTicket(correo, this.$fun.getUserID())
							.then(r => {
								this.dialogLoading = false;
								this.dialog = false;
								this.$fun.alert("Enviado Correctamente", "success");
							})
							.catch(error => {
                                console.error("Error al enviar:", error);
								this.dialogLoading = false;
								this.$fun.alert("Error al enviar el correo", "error");
							});
					}
				});
		}
    }
};
</script>
<style scoped>
/* Contenedor general del correo */
.email-container {
	max-width: 800px;
	margin: 0 auto;
	padding: 16px;
	font-family: Arial, sans-serif;
	color: #202124;
}
.email-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 16px;
	border-bottom: 1px solid #e0e0e0;
}
.email-title {
	font-size: 20px;
	font-weight: 400;
}
.email-label {
	background-color: #f1f3f4;
	color: #5f6368;
	padding: 0px 4px;
	border-radius: 4px;
	font-size: 11px;
	display: inline-flex;
	align-items: center;
}
.close-icon {
	margin-left: 4px;
	cursor: pointer;
	font-size: 16px;
	color: #5f6368;
	transform: translateY(-1px);
}
.email-actions {
	display: flex;
	justify-content: flex-end;
	gap: 12px;
}
.sender-info {
	display: flex;
	align-items: center;
	padding: 16px 0;
}
.profile-image {
	width: 40px;
	height: 40px;
	border-radius: 50%;
	overflow: hidden;
	margin-right: 12px;
	border: 0.5px solid #c0c1c5;
}
.sender-details {
	flex-grow: 1;
}
.sender-email {
	font-weight: bold;
	font-size: 12px;
}
.recipient {
	font-size: 12px;
	color: #5f6368;
	display: flex;
	align-items: center;
}
.email-timestamp {
	font-size: 11px;
	color: #5f6368;
	display: flex;
	align-items: center;
	gap: 5px;
}
.email-options {
	display: flex;
	align-items: center;
	gap: 10px;
}
.email-content {
	padding: 10px 0;
	font-size: 12px;
}
.email-divider {
	height: 1px;
	background-color: #e0e0e0;
	margin: 16px 0;
}
.attachment-section-container {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 16px;
}
.attachment-container {
	border: 1px solid #e0e0e0;
	border-radius: 4px;
	max-width: 100%;
	padding: 16px;
	background-color: #fff;
	margin: 0 auto;
	position: relative;
}
.attachment-preview {
	width: 100%;
	height: auto;
	overflow: visible;
	text-align: center;
}
.attachment-preview img {
	max-width: 100%;
	height: auto;
	display: block;
	margin: 0 auto;
	object-fit: contain;
}
#editor .ql-editor {
	padding: 0 !important;
}
.ql-editor p {
	margin: 0;
}
.email-label {
	font-weight: 500;
	color: #555;
	font-size: 0.9rem;
}
.email-value {
	font-weight: 600;
	color: #333;
	cursor: pointer;
}
.email-value:hover {
	text-decoration: underline;
}
</style>
